import jQuery from 'jquery';
import AuthenticationUtil from 'utils/AuthenticationUtil';
import ViewerUserPreferences from 'models/user/ViewerUserPreferences';
import SnackbarMessageAction from 'system/SnackbarMessageAction';
import { isReadonlyMode } from 'system/SystemUtil';

jQuery.ajaxSetup({
    headers: {
        NK: 'NT',
        'X-app-ver': window.URL_BUST_VALUE,
        'X-lang': ViewerUserPreferences.getFullLocale()
    }
});

jQuery(document).ajaxError(function(event, xhr, settings) {
    if (xhr.status === 401) {
        AuthenticationUtil.signOut();
        return;
    }

    // Ignore userpreference error in Readonly Mode
    if (settings.url.startsWith('/userpreference-service') && isReadonlyMode()) {
        return;
    }

    if (xhr.status === 403 && isReadonlyMode()) {
        SnackbarMessageAction.display({ ns: 'settings', transKey: 'read_only_mode_alert_2' });
    }
});
